import { OnChanges, SimpleChanges } from '@angular/core';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatStepper } from '@angular/material/stepper';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { cloneArray } from 'src/app/app.component';
import { OnboardingManagerService } from 'src/app/modules/my-journey/components/onboarding-manager/services/onboarding-manager.service';

import { FilesService } from 'src/app/services/shared/files/files.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { getInvalidFields, getInvalidFieldsV3, viewDocument } from '../../functions/functions';
import { markFormGroupTouched } from '../dynamic-form/dynamic-form.component';

@Component({
  selector: 'tm-dynamic-form-v3',
  templateUrl: './tm-dynamic-form-v3.component.html',
  styleUrls: ['./tm-dynamic-form-v3.component.scss'],
  providers: [OnboardingManagerService, FilesService]
})
export class TmDynamicFormV3Component implements OnInit, OnChanges {
  @Input() sections = [];
  @Input() verification_status_list = [];
  @Input() verificationObj = {}
  @Input() extra_data;
  @Input() display_type;
  @Input() dynamic_form_group;
  @Input() main_form;
  @Input() masters;
  @Input() parent_form;
  @Input() verificationRequired;
  @Input() callbackFn;
  @Input() disable_button;
  @Output() dataSaved = new EventEmitter<any>();
  @Output() fieldClick = new EventEmitter<any>();
  @Output() formDetails = new EventEmitter<any>();
  @Input() alertId;
  @Input() type;
  @Input() disabled;
  @Input() extended_fields_titles;
  @Input() sec_data;
  @Input() all_form;


  @ViewChild('panel') panel: MatExpansionPanel;
  constructor(
    private api: OnboardingManagerService,
    private notification: NotificationService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private fb: UntypedFormBuilder,
    private file_srv: FilesService,
    private change_detector: ChangeDetectorRef
  ) { }
  addPanelRefToSectionRef = this.addPanelRefToSection.bind(this);
  stepperOrientation = 'horizontal'
  ngOnInit(): void {
    this.stepperOrientation = 'vertical'
  }

  addPanelRefToSection(elem_Ref, section, panel) {
    section.ref = panel;
  }

  openNotesModal(item) {
    if (this.fieldClick) {
      this.fieldClick.emit({
        func: 'openNotes',
        data: item
      })
    }

  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
    this.change_detector.detectChanges()
  }

  accordionPanelClosed(control_name, panel, form_group, section, parent_form) {
    let fg = form_group;
    setTimeout(() => {
      // if (section.multiple) {
      //   // fg = parent_form;
      // }
      if (fg.getRawValue()[control_name] == 1) {
        panel.open();
        section.openAccrodion = 1;
      }
      else {
        panel.close();
        section.openAccrodion = 0;
      }
    });
  }

  toggleAccordion(section) {
    section.openAccrodion = !section.openAccrodion;
  }

  transformFn(controlName, transform) {
    if ((controlName).getRawValue()) {
      if (transform == 1) {
        controlName.setValue((controlName.getRawValue()).toUpperCase())
      }
      else if (transform == 2) {
        controlName.setValue((controlName.getRawValue()).toLowerCase())
      }
    }
  }


  onEmailClick(ev?) {

  }

  checkForMasterTable(section_index, l) {
    let section = this.sections[section_index];
    if (section_index < this.sections.length) {
      let len = section.sectionFields && section.sectionFields.length;
      if (l < len) {
        let field = section.sectionFields[l];
        if (field.masterId && field.masterId > 0 && field.masterId != '' && !field.list) {
          this.api.getMasterTable({
            tableId: field.masterId,
            status: 1,
            code: 0
          }).subscribe(res => {
            if (res && res['data']) {
              field['list'] = res['data'].list;
            }
            this.checkForMasterTable(section_index, l + 1)
          })
        }
        else {
          this.checkForMasterTable(section_index, l + 1)
        }
      }
      else {
        this.checkForMasterTable(section_index + 1, 0)
      }
    }
    else {
      this.sections = cloneArray(this.sections)
    }
  }
  viewDocument(all_files, file) {
    viewDocument(all_files, file, this.dialog)
  }

  saveSection(section, form) {
    if (section && section.sectionFields && section.sectionFields.length) {
      if (form.valid) {
        if (form && form.getRawValue()) {
          let keys = Object.keys(form.getRawValue());
          keys.forEach(k => {
            section.sectionFields.forEach(field => {
              if (field.title == k) {
                field.value = form.getRawValue()[k];
              }
            })
          })
        }
        this.dataSaved.emit(section);
      }
      else {
        markFormGroupTouched(form);
        this.scrollToError();
        getInvalidFields(form, this.translate, this.notification, null, 1);
        return;
      }
    }
  }

  TextValueChanges(ev, form, control_name) {
    // let value = form.controls[control_name].value;
    // let func = "new Date(value).getTime() >= new Date().getTime()?'Valid input':'Invalid Input'"
    // let message = eval(func)
    // this.notification.success(message, 'Close', 5000)
  }


  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      ".ng-invalid[formControlName]"
    );
    this.scrollTo(firstElementWithError);
  }

  previous(stepper: MatStepper, index, section) {
    try {
      stepper.previous();
    }
    catch (err) {

    }

    try {
      document.getElementById('chck' + (index - 1))['checked'] = true;
      this.scrollTo(document.getElementById('chck' + (index - 1)));
    }
    catch (err) {

    }
  }

  steppr;
  currentIndex;
  saveDetails(section, stepper, form_group, parent_form, sections, add_callback, masters, current_section_index?, sec_checkbox_id?) {
    this.steppr = stepper;
    this.currentIndex = current_section_index;
    if (this.validityCheck(section, form_group, masters, current_section_index, sections, parent_form, sec_checkbox_id)) {
      if (this.validityCheckTillIndex(current_section_index, stepper, sections, parent_form)) {
        if (section && section.hasDocument && section.hasDocument.keys && section.hasDocument.keys.length) {
          let total_uploaded_documents = 0;
          for (let i = 0; i < section.hasDocument.keys.length; i++) {
            let dockey = section.hasDocument.keys[i];
            this.uploadDocument(form_group.get(dockey).getRawValue()).subscribe(res => {
              total_uploaded_documents = total_uploaded_documents + 1;
              if (res) {
                form_group.get(dockey).patchValue(res);
              }
              setTimeout(() => {
                if (total_uploaded_documents == section.hasDocument.keys.length) {
                  let final_obj = {};

                  this.formatValues(parent_form.getRawValue(), sections, final_obj);

                  if (section.additionalKeysBody) {
                    Object.assign(final_obj, section.additionalKeysBody);
                  }
                  this.submitDetails(final_obj, add_callback, current_section_index);
                }
              }, 100);

            })
          }
        }
        else {

          let final_obj = {};

          this.formatValues(parent_form.getRawValue(), sections, final_obj);

          if (section.additionalKeysBody) {
            Object.assign(final_obj, section.additionalKeysBody);
          }
          this.submitDetails(final_obj, add_callback, current_section_index);

        }
      }
    }

  }

  optionSelected(ev, expression, form_group, field_obj) {
    console.log(ev);
    if (ev && expression) {
      try {
        eval(expression);
      }
      catch (err) {

      }
    }

    try {
      if (field_obj.parent_key && field_obj.enable_virtual_scroll && ev && ev[field_obj.title_property || 'title']) {
        if (!this.extended_fields_titles[field_obj.parent_key]) {
          this.extended_fields_titles[field_obj.parent_key] = {}
        }
        let out_obj = {};
        out_obj[field_obj['masterTitleProperty']] = ev[field_obj.title_property || 'title']
        Object.assign(this.extended_fields_titles[field_obj.save_title_parent_key], out_obj)

      }
    }
    catch (err) {

    }

    this.change_detector.detectChanges()

  }

  submitDetails(final_obj, add_callback, index) {
    this.formDetails.emit(({
      value: final_obj,
      callbacFn: add_callback ? this.saveCallbackfn.bind(this) : null,
      extended_fields_titles: this.extended_fields_titles,
      currentIndex: index
    }))
  }

  uploadDocument(file_obj, file_name = "digital-sign.png") {
    return new Observable(obs => {
      // if (type == 1) {
      try {
        let base64;
        let file_title;
        let mime_type;
        try {
          base64 = (file_obj.base64 ? file_obj.base64 : file_obj.content);
          file_title = (file_obj.fileName);
          mime_type = (file_obj.mimeType);
        }
        catch (err) {

        }

        if (base64) {
          base64 = base64;
        }
        else {
          base64 = file_obj;
        }
        if (file_title) {
          file_name = file_title;
        }

        let file = dataURLtoFile(base64, file_name)
        let form_data = new FormData();
        form_data.append('attachment', file, file.name);
        this.notification.success('FILES.uploading_attachments', 'Close', 3000);
        this.file_srv.uploadAttachment(form_data).subscribe(res => {

          let attach = {}
          if (res && res['data']) {

            attach['fileName'] = res['data']['a_fn'];
            attach['cdnPath'] = res['data']["a_url"];

            obs.next([attach]);
            this.notification.success(res['message'], 'Close', 3000);
            // attach['width'] = this.result_dimentions[0].width
            // attach['height'] = this.result_dimentions[0].heigh
          }
          else {
            obs.next(0)
            this.notification.error(res && res['message'], 'Close', 3000);
          }
        }, err => {
          obs.next(0);
        })
      } catch (error) {
        obs.next(0)
      }
      // }

    })

  }

  formatValues(value, section, obj) {
    if (section && section && section.length && typeof section == 'object') {
      for (let i = 0; i < section.length; i++) {
        let sec = section[i];
        this.formatValues(value, sec, obj)
      }

    }
    else {
      // if (section.multiple) {

      //   // Object.assign(obj, value[section.fieldID])
      // }
      // else {
      if (section.multiple) {
        Object.assign(obj, value);
      }
      else {
        Object.assign(obj, value[section.fieldID])
      }
      if (section.sections) {
        this.formatValues(value[section.fieldID], section.sections, obj)
      }
      // }

    }
  }

  saveCallbackfn(ind) {
    console.log(document.querySelectorAll('.tabId'))
    try {
      this.steppr.next();
    }
    catch (err) {

    }

    try {
      document.getElementById('chck' + (ind))['checked'] = false;
      document.getElementById('chck' + (ind + 1))['checked'] = true;
      this.scrollTo(document.getElementById('chck' + (ind + 1)));
    }
    catch (err) {

    }
    // console.log('callback');
  }
  validityCheckTillIndex(current_section_index, stepper, sections, parent_form) {
    for (let k = 0; k < this.sections.length; k++) {
      const element = this.sections[k];
      if (current_section_index > k && !element?.validators?.hide?.value) {
        if (!(this.validityCheck(this.sections[k], this.dynamic_form_group.get(this.sections[k].fieldID), this.masters, current_section_index, sections, parent_form, 'chck' + k))) {
          try {
            stepper.selectedIndex = k;
          } catch (error) {

          }
          return false;
        }
      }
    }
    return true;
  }

  validityCheck(section, form_group, masters, current_section_index, sections, parent_form, sec_checkbox_id) {
    if (form_group && form_group.valid) {

      let value = form_group.getRawValue();
      let status = true;

      if (section && section.hasDocument && section.hasDocument.keys && section.hasDocument.keys.length) {
        let total_uploaded_documents = 0;
        for (let i = 0; i < section.hasDocument.keys.length; i++) {
          let dockey = section.hasDocument.keys[i];
          this.uploadDocument(form_group.get(dockey).getRawValue()).subscribe(res => {
            total_uploaded_documents = total_uploaded_documents + 1;
            if (res) {
              form_group.get(dockey).patchValue(res);
            }
            setTimeout(() => {
              if (total_uploaded_documents == section.hasDocument.keys.length) {
                let final_obj = {};

                this.formatValues(parent_form.getRawValue(), sections, final_obj);

                if (section.additionalKeysBody) {
                  Object.assign(final_obj, section.additionalKeysBody);
                }
                // this.submitDetails(final_obj, add_callback);
              }
            }, 100);

          })
        }
      }
      if (section && section.sectionFields) {
        for (let index = 0; index < section.sectionFields.length; index++) {
          const element = section.sectionFields[index];
          if (element.dataTypeId == 16 && element.UIValidationObjStruct && element.UIValidationObjStruct.mandatory && element.UIValidationObjStruct.mandatory.value) {
            for (let j = 0; j < form_group.getRawValue()[element.fieldID].length; j++) {
              if (form_group.getRawValue()[element.fieldID][j] && form_group.getRawValue()[element.fieldID][j]['attachValue'] && form_group.getRawValue()[element.fieldID][j]['attachValue'].length || !(form_group.getRawValue()[element.fieldID][j] && form_group.getRawValue()[element.fieldID][j]['UIValidationObjStruct'] && form_group.getRawValue()[element.fieldID][j].UIValidationObjStruct.mandatory && form_group.getRawValue()[element.fieldID][j].UIValidationObjStruct.mandatory.value) || (form_group.getRawValue()[element.fieldID][j] && form_group.getRawValue()[element.fieldID][j]['UIValidationObjStruct'] && form_group.getRawValue()[element.fieldID][j].UIValidationObjStruct.hide && form_group.getRawValue()[element.fieldID][j].UIValidationObjStruct?.hide?.value)) {

              }
              else {
                this.notification.error(form_group.getRawValue()[element.fieldID][j].attachLabel + ' is mandatory', 'Close', 5000)
                return false;
              }

            }
            // masters[element.masterPropName]
          }
          if (element.dataTypeId == 23) {
            for (let j = 0; j < form_group.getRawValue()[element.fieldID].length; j++) {
              if (form_group.getRawValue()[element.fieldID][j] && form_group.getRawValue()[element.fieldID][j]['agreedStatus'] || !(form_group.getRawValue()[element.fieldID][j] && form_group.getRawValue()[element.fieldID][j]['UIValidationObjStruct'] && form_group.getRawValue()[element.fieldID][j].UIValidationObjStruct.mandatory)) {

              }
              else {
                this.notification.error(form_group.getRawValue()[element.fieldID][j].attachLabel + ' is mandatory', 'Close', 5000)
                return false;
              }

            }
            // masters[element.masterPropName]
          }
        }
      }
      if (section && section.sections) {
        for (let i = 0; i < section.sections.length; i++) {
          let child_section = section.sections[i];

          if (child_section.multiple) {

            if (child_section.validators.min_length) {
              if ((value[child_section.fieldID] && value[child_section.fieldID].length && value[child_section.fieldID].length >= child_section.validators.min_length)) {

              }
              else {
                try {
                  document.getElementById(sec_checkbox_id)['checked'] = true;
                }
                catch (err) {

                }
                this.scrollTo(document.getElementById(child_section.fieldID));
                this.notification.error(child_section.label + ' Section requires minimum ' + child_section.validators.min_length + ' entries', 'Close', 10000)
                status = false;
                break;
              }
            }

            else if (child_section.validators.max_length) {
              if ((value[child_section.fieldID] && value[child_section.fieldID].length && value[child_section.fieldID].length <= child_section.validators.max_length)) {

              }
              else {
                try {
                  document.getElementById(sec_checkbox_id)['checked'] = true;
                }
                catch (err) {

                }
                this.scrollTo(document.getElementById(child_section.fieldID));
                this.notification.error(child_section.label + ' can have maximum of ' + (child_section.validators.max_length) + ' entries', 'Close', 10000)
                status = false;
                break;
              }
            }
          }
        }
        return status;
      }
      else {
        return true;
      }
    }
    else {
      try {
        document.getElementById(sec_checkbox_id)['checked'] = true;
      }
      catch (err) {

      }
      setTimeout(() => {
        markFormGroupTouched(form_group);
        getInvalidFieldsV3(form_group, this.translate, this.notification, section);
      });

    }
  }

  fetchMasterEntries(ev, route, masters, field, section) {
    this.api.getMasters(route, ev).subscribe(res => {
      if (res && res['data'] && res['data'].list) {
        if (section && section.multiple) {
          let fieldValue = this.dynamic_form_group.value[section.fieldID];
          if (fieldValue && fieldValue.length) {
            for (let i = 0; i < fieldValue.length; i++) {
              let fieldValueItem = fieldValue[i][field.fieldID];
              if (fieldValueItem) {
                let match = masters[field.masterPropName].find(item => item.id === fieldValueItem);
                if (match) {
                  let list = res['data'].list;
                  if (Array.isArray(list)) {
                    let listMatch = list.find(item => item.id === fieldValueItem);
                    if (listMatch) {
                      masters[field.masterPropName] = cloneArray(list);
                    }
                    else {
                      list.push(match);
                      masters[field.masterPropName] = cloneArray(list);
                    }
                  }
                  else {
                    masters[field.masterPropName] = cloneArray(res['data'].list);
                  }
                }
                else {
                  masters[field.masterPropName] = cloneArray(res['data'].list);
                }
              }
              else {
                masters[field.masterPropName] = cloneArray(res['data'].list);
              }
            }
          }
          else {
            masters[field.masterPropName] = cloneArray(res['data'].list);
          }

        }
        else {
          masters[field.masterPropName] = cloneArray(res['data'].list);
        }
      }
    })
  }

}

export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

